import { render, staticRenderFns } from "./investors.vue?vue&type=template&id=71b016f8&scoped=true&"
import script from "./investors.vue?vue&type=script&lang=js&"
export * from "./investors.vue?vue&type=script&lang=js&"
import style0 from "./investors.vue?vue&type=style&index=0&id=71b016f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b016f8",
  null
  
)

export default component.exports